module.exports = __webpack_public_path__ + "494cd07c/img/pwrd-by-sourcery-black.bba9ba41.svg";